import React, { useState, memo } from 'react';
import MultiSelectSearch from '../../components/MultiSelectSearch/MultiSelectSearch';
import ProfessionalSearch from '../../components/ProfessionalSearch/ProfessionalSearch';
import { ENDPOINTS, GLOBAL_CALENDAR_SHIFT_TYPES } from '../../constants';

const GlobalOverviewFilters = ({
	activeOptions,
	selectedCaregiver,
	handleMultiSelectFiltersApply,
	removeSelectedCaregiver,
	handleCaregiverFilterSelection,
	globalScheduleType,
	areAllFacilitiesSelected
}) => {
	const [isCaregiverSelectOpen, setIsCaregiverSelectOpen] = useState(false);

	const handleRemoveCaregiver = () => {
		setIsCaregiverSelectOpen(false);
		removeSelectedCaregiver();
	};

	const shouldShowUnitsFilter =
		(areAllFacilitiesSelected && activeOptions.units.length > 0) || !areAllFacilitiesSelected;
	const isUnitsFilterDisabled = !areAllFacilitiesSelected && activeOptions.units.length === 0;

	return (
		<div className="filters-container">
			<div className="inline-filters">
				<MultiSelectSearch
					showLongSelectionText
					className="select-filter-type-container"
					label="Shift type"
					options={activeOptions.resourceTypes}
					onApply={(options) => handleMultiSelectFiltersApply('resourceTypes', options)}
				/>
				<MultiSelectSearch
					showLongSelectionText
					className="select-filter-status-container"
					label="Status"
					options={activeOptions.statuses}
					onApply={(options) => handleMultiSelectFiltersApply('statuses', options)}
				/>
				{globalScheduleType === GLOBAL_CALENDAR_SHIFT_TYPES.ALL && (
					<MultiSelectSearch
						showLongSelectionText
						className="select-filter-status-container"
						label="Shift route"
						options={activeOptions.shiftRoutes}
						onApply={(options) => handleMultiSelectFiltersApply('shiftRoutes', options)}
					/>
				)}
				{shouldShowUnitsFilter && (
					<MultiSelectSearch
						showLongSelectionText
						className="select-filter-status-container"
						label="Units"
						options={activeOptions.units}
						onApply={(options) => handleMultiSelectFiltersApply('units', options)}
						disabled={isUnitsFilterDisabled}
					/>
				)}
				{(globalScheduleType === GLOBAL_CALENDAR_SHIFT_TYPES.ALL ||
					globalScheduleType === GLOBAL_CALENDAR_SHIFT_TYPES.ON_DEMAND) && (
					<MultiSelectSearch
						showLongSelectionText
						className="select-filter-status-container"
						label="Features"
						options={activeOptions.features}
						onApply={(options) => handleMultiSelectFiltersApply('features', options)}
					/>
				)}
			</div>
			<ProfessionalSearch
				className="filter-item push-right"
				selectedCaregiver={selectedCaregiver}
				setSelectedCaregiver={handleCaregiverFilterSelection}
				isOpen={isCaregiverSelectOpen}
				setIsOpen={setIsCaregiverSelectOpen}
				removeSelectedCaregiver={handleRemoveCaregiver}
				emptyListPlaceholder="No enabled professionals found"
				placeholder="Search for professional"
				clearVariantButton="WARNING"
				textVariant="BOLD"
				type={globalScheduleType}
				searchURL={ENDPOINTS.SEARCH_ACTIVE_WORKER}
			/>
		</div>
	);
};

export default memo(GlobalOverviewFilters);
